<template>
  <div class="area-form-container">
    <!-- 面包屑 -->
    <div class="breadcrumb-wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i>首页
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/venueList' }">展馆展区管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ isEdit ? '编辑展区' : '新增展区' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="form-card" shadow="hover">
      <div class="card-head">
        <h2 class="form-title">
          <i class="el-icon-s-shop"></i>
          {{ isEdit ? '编辑展区信息' : '新增展区' }}
        </h2>
      </div>

      <el-form
        ref="areaFormRef"
        :model="formData"
        :rules="formRules"
        label-width="120px"
        size="mini"
        class="area-form"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="关联展馆" prop="venue_id">
              <el-select
                v-model="formData.venue_id"
                placeholder="请选择所属展馆"
                clearable
                filterable
                style="width:100%"
              >
                <el-option
                  v-for="item in venueList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="展区名称" prop="area_name">
              <el-input
                v-model="formData.area_name"
                placeholder="输入展区名称，如1号展厅A区"
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="所在省市">
              <el-cascader
                ref="cascaderAddr"
                style="width:100%"
                v-model="areaSelect"
                clearable
                filterable
                :props="propsdata"
                placeholder="跟随展馆地址/单独设置展区地址"
                @change="handleAreaAddrChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="展区详细地址" prop="address">
              <el-input
                v-model="formData.address"
                placeholder="精确楼层、门牌号"
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="展区总面积(㎡)" prop="area_size">
              <el-input-number
                v-model="formData.area_size"
                :min="0"
                :precision="2"
                style="width:100%"
                placeholder="展区实际使用面积"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最大容纳人数" prop="max_capacity">
              <el-input-number
                v-model="formData.max_capacity"
                :min="0"
                style="width:100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="标准展位数量" prop="booth_num">
              <el-input-number
                v-model="formData.booth_num"
                :min="0"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="特装空地面积(㎡)">
              <el-input-number
                v-model="formData.open_area"
                :min="0"
                :precision="2"
                style="width:100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="展区状态" prop="status">
              <el-select v-model="formData.status" style="width:100%">
                <el-option label="正常可用" value="1" />
                <el-option label="维护关闭" value="0" />
                <el-option label="临时停用" value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="适合展会类型" prop="exhibition_type">
              <el-select v-model="formData.exhibition_type" style="width:100%">
                <el-option label="消费零售展" value="1" />
                <el-option label="B2B专业行业展" value="2" />
                <el-option label="政企会议会展" value="3" />
                <el-option label="户外大型特展" value="4" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="配套设施">
              <el-checkbox-group v-model="formData.support_list">
                <el-checkbox label="标准展位" value="booth" />
                <el-checkbox label="配套会议室" value="meeting" />
                <el-checkbox label="大型停车场" value="park" />
                <el-checkbox label="仓储物流区" value="storage" />
                <el-checkbox label="餐饮休息区" value="food" />
                <el-checkbox label="LED大屏" value="screen" />
                <el-checkbox label="水电全通" value="water_electric" />
              </el-checkbox-group>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="展区备注说明">
              <el-input
                v-model="formData.remark"
                type="textarea"
                :rows="4"
                placeholder="填写层高、承重、消防限制、租赁价格、使用限制等信息"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 底部操作按钮 -->
        <div class="btn-group">
          <el-button size="mini" type="primary" icon="el-icon-check" @click="submitForm">保存提交</el-button>
          <el-button size="mini" icon="el-icon-refresh-left" @click="resetForm">重置</el-button>
          <el-button size="mini" icon="el-icon-back" @click="goBack">返回列表</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>

export default {
  name: "venueAreaForm",
  data() {
    return {
      // 编辑ID
      id: this.$route.query.id || '',
      venue_id: this.$route.query.venue_id || '',
      isEdit: false,
      // 地区级联配置 和列表页保持一致
      areaSelect: [],
      propsdata: {
        checkStrictly: true,
        lazy: true,
        lazyLoad(node, resolve) {
          const url = '/api/api/cmp.sys.Region_read_lz/findRegionList';
          const param = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id'),
            parent_id: node.value
          }
          if (node.level === 0) param.parent_id = 1
          this.$axios.post(url, param).then(res => {
            if (res.data.code === 200) {
              const nodes = res.data.data.map(item => ({
                value: item.id,
                label: item.name,
                leaf: node.level >= 2
              }))
              resolve(nodes)
            }
          }).catch(() => resolve([]))
        }
      },
      // 展馆下拉数据源
      venueList: [],
      // 表单数据
      formData: {
        venue_id: '',
        area_name: '',
        province_id: '',
        city_id: '',
        district_id: '',
        address: '',
        area_size: null,
        max_capacity: null,
        booth_num: null,
        open_area: null,
        status: '1',
        exhibition_type: '1',
        support_list: [],
        remark: ''
      },
      // 表单校验规则
      formRules: {
        venue_id: [{ required: true, message: '请选择关联展馆', trigger: 'change' }],
        area_name: [{ required: true, message: '请填写展区名称', trigger: 'blur' }],
        area_size: [{ required: true, message: '请填写展区面积', trigger: 'blur' }],
        max_capacity: [{ required: true, message: '请填写容纳人数', trigger: 'blur' }],
        status: [{ required: true, message: '请选择展区状态', trigger: 'change' }],
        exhibition_type: [{ required: true, message: '请选择展会适配类型', trigger: 'change' }]
      }
    }
  },
  created() {
    this.isEdit = !!this.id
    this.getVenueSelectList()
    // 编辑回显数据
    if (this.isEdit) {
      this.getAreaDetail()
    } else {
      // 从展馆列表跳转带venue_id，自动赋值
      if (this.venue_id) {
        this.formData.venue_id = this.venue_id
      }
    }
  },
  methods: {
    // 获取展馆下拉选项
    getVenueSelectList() {
      const params = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        pageNum: 1,
        pageSize: 999
      }
      this.$axios.findVenueListP(params).then(res => {
        if (res.code === 200) {
          this.venueList = res.data.data || []
        }
      })
    },
    // 获取编辑详情
    getAreaDetail() {
      const params = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        id: this.id
      }
      this.$axios.get('/api/venue/getExhibitionAreaDetail', { params }).then(res => {
        if (res.code === 200) {
          const data = res.data
          this.formData = {
            venue_id: data.venue_id,
            area_name: data.area_name,
            province_id: data.province_id,
            city_id: data.city_id,
            district_id: data.district_id,
            address: data.address,
            area_size: data.area_size,
            max_capacity: data.max_capacity,
            booth_num: data.booth_num,
            open_area: data.open_area,
            status: data.status,
            exhibition_type: data.exhibition_type,
            support_list: data.support_list || [],
            remark: data.remark
          }
          // 回显省市区级联
          if (data.province_id) {
            this.areaSelect = [data.province_id, data.city_id, data.district_id].filter(Boolean)
          }
        } else {
          this.$message.error(res.msg || '获取详情失败')
          this.goBack()
        }
      })
    },
    // 地区选择赋值
    handleAreaAddrChange(value) {
      if (value && value.length > 0) {
        this.formData.province_id = value[0] || ''
        this.formData.city_id = value[1] || ''
        this.formData.district_id = value[2] || ''
      } else {
        this.formData.province_id = ''
        this.formData.city_id = ''
        this.formData.district_id = ''
      }
    },
    // 提交表单
    submitForm() {
      this.$refs.areaFormRef.validate(valid => {
        if (!valid) return
        const submitParam = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          operator_id: sessionStorage.getItem('user_id'),
          ...this.formData
        }
        // 编辑携带ID
        if (this.isEdit) submitParam.id = this.id

        const apiUrl = this.isEdit ? '/api/venue/updateExhibitionArea' : '/api/venue/addExhibitionArea'
        this.$axios.post(apiUrl, submitParam).then(res => {
          if (res.code === 200) {
            this.$message.success(this.isEdit ? '展区编辑成功' : '展区新增成功')
            this.goBack()
          } else {
            this.$message.error(res.msg || '操作失败')
          }
        }).catch(() => {
          this.$message.error('网络请求异常，请重试')
        })
      })
    },
    // 重置表单
    resetForm() {
      this.$refs.areaFormRef.resetFields()
      this.areaSelect = []
      // 恢复默认状态
      this.formData.status = '1'
      this.formData.exhibition_type = '1'
      this.formData.support_list = []
    },
    // 返回展馆列表页
    goBack() {
      this.$router.push('/venueList')
    }
  }
}
</script>

<style scoped>
/* 支付宝全局主题穿透，和列表页统一 */
:deep(.el-card) {
  border-radius: 8px;
  border: 1px solid #e5e6eb;
}
:deep(.el-button--primary) {
  background-color: #1677ff;
  border-color: #1677ff;
}
:deep(.el-input__inner) {
  border-radius: 4px;
}
:deep(.el-input-number__inner) {
  border-radius: 4px;
}

.area-form-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 84px);
}

.breadcrumb-wrap {
  margin-bottom: 16px;
}

.form-card {
  padding: 10px;
}

.card-head {
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}

.form-title {
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
  margin: 0;
  display: flex;
  align-items: center;
}

.form-title i {
  color: #1677ff;
  margin-right: 8px;
  font-size: 18px;
}

.area-form {
  padding: 10px 0;
}

.btn-group {
  margin-top: 30px;
  display: flex;
  gap: 10px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .area-form-container {
    padding: 10px;
  }
  :deep(.el-col) {
    width: 100% !important;
  }
  .btn-group {
    flex-wrap: wrap;
  }
}
</style>